import { FC } from "react"
import { PageHeader } from "#dashboard/components/pageHeader.component"
import { B2bTable } from "#b2b/components/b2bTable.component"
import { CreateNewB2bAccount } from "#b2b/components/createB2b.component"

export const B2bPage: FC = () => {
    return <>
        <PageHeader header={'B2B'} />
        <B2bTable />
        <CreateNewB2bAccount />
    </>
}
